import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { IconTool } from '@tabler/icons-react';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import NaverCallbackPage from './pages/NaverCallbackPage';
import KakaoCallbackPage from './pages/KakaoCallbackPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import HomePage from './pages/HomePage';
import api from './api/api';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [maintenance, setMaintenance] = useState(null); // null=로딩, false=정상, { message }=점검중

  useEffect(() => {
    document.body.className = 'antialiased';

    // URL에서 token, refreshToken 쿼리 파라미터 확인 (impersonate 로그인용)
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const refreshToken = params.get('refreshToken');

    if (token && refreshToken) {
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      setIsLoggedIn(true);
      window.history.replaceState({}, document.title, window.location.pathname);
    } else {
      const savedToken = localStorage.getItem('token') || sessionStorage.getItem('token');
      if (savedToken) setIsLoggedIn(true);
    }

    // 점검모드 확인
    api.get('/system-config').then(res => {
      const config = res.data;
      if (config['site.maintenanceMode'] === 'true') {
        setMaintenance({
          message: config['site.maintenanceMessage'] || '시스템 점검 중입니다.',
          siteName: config['site.name'] || 'AI65 Neo',
          logo: config['site.logo'] || '',
        });
      } else {
        setMaintenance(false);
      }
    }).catch(() => {
      setMaintenance(false);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  if (loading) return null;

  // 점검모드 화면
  if (maintenance) {
    return <MaintenancePage maintenance={maintenance} />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/auth/naver/callback" element={<NaverCallbackPage setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/auth/kakao/callback" element={<KakaoCallbackPage setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/change-password" element={<ChangePasswordPage setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/*" element={isLoggedIn ? <HomePage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

/** 점검모드 안내 페이지 */
function MaintenancePage({ maintenance }) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      padding: 24,
    }}>
      <div style={{
        background: '#fff', borderRadius: 20, padding: '56px 44px',
        maxWidth: 480, width: '100%', textAlign: 'center',
        boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
      }}>
        {/* 로고 */}
        {maintenance.logo ? (
          <img src={maintenance.logo} alt="로고"
            style={{ width: 72, height: 72, borderRadius: 16, objectFit: 'contain', margin: '0 auto 24px', display: 'block' }} />
        ) : (
          <div style={{
            width: 72, height: 72, borderRadius: 16,
            background: 'linear-gradient(135deg, #f59f00, #f76707)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 24px', color: '#fff',
          }}>
            <IconTool size={36} />
          </div>
        )}

        <h1 style={{ fontWeight: 800, fontSize: 26, marginBottom: 12, color: '#212529' }}>
          시스템 점검 중
        </h1>

        <p style={{
          fontSize: 15, lineHeight: 1.8, color: '#868e96',
          marginBottom: 32, whiteSpace: 'pre-line',
        }}>
          {maintenance.message}
        </p>

        <div style={{
          background: '#f8f9fa', borderRadius: 12, padding: '16px 20px',
          fontSize: 13, color: '#868e96',
        }}>
          더 나은 서비스를 위해 점검을 진행하고 있습니다.<br />
          빠른 시간 내에 정상화하겠습니다.
        </div>

        <div style={{ marginTop: 24, fontSize: 13, color: '#adb5bd' }}>
          &copy; {new Date().getFullYear()} {maintenance.siteName}
        </div>
      </div>
    </div>
  );
}

export default App;
